import { render, staticRenderFns } from "./orderTrack.vue?vue&type=template&id=b8a362e2&scoped=true&"
import script from "./orderTrack.vue?vue&type=script&lang=js&"
export * from "./orderTrack.vue?vue&type=script&lang=js&"
import style0 from "./orderTrack.vue?vue&type=style&index=0&id=b8a362e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a362e2",
  null
  
)

export default component.exports